import {
  Curriculum,
  DuplicateCurriculumPayload,
  useCurrentUser,
  useCurriculum,
} from "@twinkltech/curriculum-architect-domain-hooks";
import { generatePath, useNavigate } from "react-router-dom";

import { paths } from "@/paths";

import { DuplicateCurriculumModal } from "./DuplicateCurriculumModal";

export const DuplicateCurriculumModalContainer = ({
  curriculum,
  open,
  setOpen,
  shouldRedirectOnAction,
}: {
  shouldRedirectOnAction?: boolean;
  curriculum: Curriculum;
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {
  const {
    actions: { create },
    error,
    isLoading,
  } = useCurriculum();

  const navigate = useNavigate();

  const onDuplicate = async (params: {
    payload: DuplicateCurriculumPayload;
  }) => {
    const createdCurriculum = await create.apply({
      ...params,
      type: "duplicate",
    });

    if (shouldRedirectOnAction && !(createdCurriculum instanceof Error)) {
      navigate(
        generatePath(paths.CURRICULUM_SUBJECT_LIST_PATH, {
          curriculum_id: createdCurriculum.curriculumId || "",
        })
      );
    }

    return createdCurriculum;
  };
  const { data: user } = useCurrentUser();

  const schoolAccountTypes = ["school", "multi-school"];

  const isSchoolAccount = schoolAccountTypes.includes(
    user?.persona.accountType || ""
  );

  return (
    <DuplicateCurriculumModal
      curriculum={curriculum}
      error={error}
      isLoading={isLoading}
      isSchoolAccount={isSchoolAccount}
      open={open}
      setOpen={setOpen}
      onDuplicate={onDuplicate}
    />
  );
};
